// extracted by mini-css-extract-plugin
export default {"card":"c-e_eg","card_styleDefault":"c-e_eh","card_styleRed":"c-e_ei"};